import { render, staticRenderFns } from "./subscriptioncancel.vue?vue&type=template&id=060d971a&scoped=true"
import script from "./subscriptioncancel.vue?vue&type=script&lang=js"
export * from "./subscriptioncancel.vue?vue&type=script&lang=js"
import style0 from "./subscriptioncancel.vue?vue&type=style&index=0&id=060d971a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060d971a",
  null
  
)

export default component.exports